/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useContext, useState } from "react";
import { isValidEmail } from "@tomocredit/common-fe/utils/validation";
import { BreakpointContext } from "components/common";
import {
  BoostPricingTable,
} from "@tomocredit/common-fe/components";
import {
  calculatePerMonthPrice,
} from "@tomocredit/common-fe/utils";
import {
  boostProductTierConfig,
} from "@tomocredit/common-fe/consts";
import "../BoostLandingStyle.css";
import EmailInputDrawer from "./EmailInputDrawer";

/**
 * @callback redirectToCheckout
 * @param {string} tier
 * @param {string} term
 * @param {string} email
 * @returns {void}
 */

/**
 * @callback setCheckoutTier
 * @param {string} tier
 * @returns {void}
 */

/**
 * @param {Object} props
 * @param {Object} props.tiers - The tiers of the boost product
 * @param {string} props.checkoutTier - The tier that is being checked out
 * @param {string} props.checkoutTerm - The term that is being checked out
 * @param {string} props.highlightTier - The term that is being checked out
 * @param {setCheckoutTier} props.setCheckoutTier - The function to set the checkout tier
 * @param {redirectToCheckout} props.redirectToCheckout - The function to redirect to the checkout page
 * @returns
 */
export const BoostPricingComponent = ({
  tiers = [],
  checkoutTier,
  checkoutTerm,
  checkoutEmail,
  setCheckoutTier,
  redirectToCheckout,
  highlightTier = "",
}) => {
  const { isBelow } = useContext(BreakpointContext);
  const [isEmailInputVisible, setIsEmailInputVisible] = useState(false);
  const tierConfig = boostProductTierConfig[checkoutTerm]?.[checkoutTier];
  const { name = "", price = 0, originalPrice } = tierConfig || {};
  const { perMonthPrice: selectedTierPerMonthPrice } = calculatePerMonthPrice(
    checkoutTerm,
    price,
    originalPrice,
  );

  /**
   * @param {string} email
   */
  const proceedToCheckout = (email) => {
    setIsEmailInputVisible(false);
    redirectToCheckout(checkoutTier, checkoutTerm, email);
  };

  const buttonClickCallback = (tier, term) => {
    setCheckoutTier(tier);
    if (checkoutEmail && isValidEmail(checkoutEmail)) {
      redirectToCheckout(tier, term, checkoutEmail);
    } else {
      setIsEmailInputVisible(true);
    }
  };

  return (
    <>
      <BoostPricingTable
        tiers={tiers}
        highlightTier={highlightTier}
        checkoutTerm={checkoutTerm}
        buttonClickCallback={buttonClickCallback}
        isMobileView={isBelow("mdl")}
        showTable={!isBelow("xl")}
      />
      <EmailInputDrawer
        isVisible={isEmailInputVisible}
        onClose={() => setIsEmailInputVisible(false)}
        onSubmit={proceedToCheckout}
        name={name}
        price={selectedTierPerMonthPrice}
      />
    </>
  );
};
